/** news */
const issue = () => import("../../view/jofph/journal/issue");
const issueAdd = () => import("../../view/jofph/journal/issue/add");
const issueEdit = () => import("../../view/jofph/journal/issue/detail");
const article = () => import("../../view/jofph/journal/article");
const articleAdd = () => import("../../view/jofph/journal/article/add");
const preprints = () => import("../../view/jofph/journal/preprints");

const model = "/jofph";
const path = model + "/journal";

export default [
  {
    // 年卷期列表
    path: path + "/issue",
    component: issue,
    name: "journal-issue",
  },
  {
    // 新增特刊
    path: path + "/issue/add",
    component: issueAdd,
    name: "journal-issue-add",
  },
  {
    // 编辑特刊
    path: path + "/issue/:issue_id",
    component: issueEdit,
    name: "journal-issue-edit",
  },
  {
    // 文章列表
    path: path + "/article",
    component: article,
    name: "journal-article",
  },
  {
    // 新增文章
    path: path + "/article/add",
    component: articleAdd,
    name: "journal-article-add",
  },
  {
    // 编辑文章
    path: path + "/article/:article_id",
    component: articleAdd,
    name: "journal-article-edit",
  },
  {
    // 预印列表
    path: path + "/preprints",
    component: preprints,
    name: "journal-preprints",
  },
];
